import React, { useMemo } from 'react';
import { LocaleSelect } from 'components';
import { ComponentProps } from '@app/participant-fields';
import { Criterion } from 'queries';
import { useMultiSelectToCriterion } from './useMultiSelectToCriterion';

export const CriterionLocaleSelect = ({
  allowedFields,
  criteria,
  value,
  onChange,
  ...props
}: ComponentProps<Criterion>) => {
  const fieldName = props.field.name;
  const restricted =
    allowedFields && allowedFields.includes(fieldName + '_restricted');

  const countries = useMemo(() => {
    if (!criteria) {
      return [];
    }
    const criterion = criteria.find(
      ({ fieldRef }) => fieldRef === 'countryKey',
    );
    if (!criterion || !criterion.allowList) {
      return [];
    }
    return criterion.allowList as string[];
  }, [criteria]);

  const [values, _onChange] = useMultiSelectToCriterion(value, onChange);

  return (
    <LocaleSelect
      {...props}
      countries={countries}
      restricted={restricted}
      isMulti
      value={values as string[]}
      onChange={_onChange}
    />
  );
};
